var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Nav'),_vm._v(" "),_c('div',{staticStyle:{"height":"80px"}}),_vm._v(" "),_c('div',{staticClass:"download-contents"},[_c('div',{staticClass:"banner_img"},[_c('img',{attrs:{"src":_vm.webUrl,"alt":"","srcset":""}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55d64040","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/template/innerWeb.vue
// module id = null
// module chunks = 